module.exports = __webpack_public_path__ + "img/bg_zanghaomianfei.cf0ebe8e.png";